/* ==========================================================================
   NIG ヘルプセンター（FAQハブ）— 検索とアコーディオン補助
   対象テーマ: Shopify Dawn 15.5.0

   1 ファイルで 2 つの役割を持つ（読み込むページで自動的に切り替わる）。
     A. ヘルプセンタートップ … 質問文のインクリメンタル検索
     B. カテゴリページ       … #アンカー で該当質問を開く

   外部ライブラリなし。DOM への文字列挿入は textContent のみで行い、
   innerHTML は使わない（メタオブジェクトの入力値をそのまま扱うため）。
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 表記ゆれの正規化
   *   NFKC（全角英数→半角、半角カナ→全角カナ）→ 小文字化 →
   *   カタカナ→ひらがな → 小書き文字を大書きへ → 区切り記号・長音・空白の除去
   *   検索語と質問文の両方に同じ処理を掛けるので、変換は対称になる。
   *   例: ラッピング / らっぴんぐ / ﾗｯﾋﾟﾝｸﾞ / らつぴんぐ はすべて同じ形になる。
   * ------------------------------------------------------------------ */
  var NOISE = /[\s　ー－—–\-・･,、。\.．，'"”“()（）\[\]「」『』!！?？~〜\/／:：;；]/g;
  var SMALL = { 'ぁ': 'あ', 'ぃ': 'い', 'ぅ': 'う', 'ぇ': 'え', 'ぉ': 'お',
                'っ': 'つ', 'ゃ': 'や', 'ゅ': 'ゆ', 'ょ': 'よ', 'ゎ': 'わ',
                'ゕ': 'か', 'ゖ': 'け' };

  function normalize(value) {
    if (!value) return '';
    var text = String(value);
    if (text.normalize) {
      try {
        text = text.normalize('NFKC');
      } catch (e) {
        /* 古い環境では正規化なしで続行する */
      }
    }
    text = text.toLowerCase();
    text = text.replace(/[ァ-ヶ]/g, function (char) {
      return String.fromCharCode(char.charCodeAt(0) - 0x60);
    });
    text = text.replace(/[ぁぃぅぇぉっゃゅょゎゕゖ]/g, function (char) {
      return SMALL[char];
    });
    return text.replace(NOISE, '');
  }

  function tokenize(query) {
    return String(query)
      .trim()
      .split(/[\s　]+/)
      .map(normalize)
      .filter(function (token) {
        return token.length > 0;
      });
  }

  /* ------------------------------------------------------------------ *
   * A. トップページの検索
   * ------------------------------------------------------------------ */
  function initSearch(root) {
    var input = root.querySelector('[data-faq-search-input]');
    var clearButton = root.querySelector('[data-faq-search-clear]');
    var status = root.querySelector('[data-faq-search-status]');
    var results = root.querySelector('[data-faq-search-results]');
    var empty = root.querySelector('[data-faq-search-empty]');
    var emptyTerm = root.querySelector('[data-faq-search-term]');
    var browse = root.querySelector('[data-faq-browse]');
    var dataNode = root.querySelector('[data-faq-index]');
    if (!input || !results || !dataNode) return;

    var limit = parseInt(root.getAttribute('data-limit'), 10) || 20;
    var items = [];

    try {
      items = JSON.parse(dataNode.textContent || '[]');
    } catch (e) {
      return; // データが壊れているときは検索窓を素通りさせる（一覧は表示され続ける）
    }

    items.forEach(function (item) {
      item.nq = normalize(item.q);
      item.nc = normalize(item.c);
    });

    function matches(item, tokens, withCategory) {
      var haystack = withCategory ? item.nq + item.nc : item.nq;
      for (var i = 0; i < tokens.length; i++) {
        if (haystack.indexOf(tokens[i]) === -1) return false;
      }
      return true;
    }

    function search(tokens) {
      var hits = items.filter(function (item) {
        return matches(item, tokens, false);
      });
      if (hits.length > 0) return { hits: hits, widened: false };

      // 質問文で 0 件のときだけ、カテゴリ名も含めて探し直す
      hits = items.filter(function (item) {
        return matches(item, tokens, true);
      });
      return { hits: hits, widened: hits.length > 0 };
    }

    function rank(hits, tokens) {
      var head = tokens[0];
      return hits
        .map(function (item, index) {
          var position = item.nq.indexOf(head);
          return { item: item, position: position < 0 ? 9999 : position, index: index };
        })
        .sort(function (a, b) {
          return a.position - b.position || a.index - b.index;
        })
        .map(function (entry) {
          return entry.item;
        });
    }

    function render(hits) {
      results.textContent = '';
      hits.slice(0, limit).forEach(function (item) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.className = 'faq-search__link';
        link.href = item.u;

        var question = document.createElement('span');
        question.className = 'faq-search__q';
        question.textContent = item.q;
        link.appendChild(question);

        if (item.c) {
          var category = document.createElement('span');
          category.className = 'faq-search__cat';
          category.textContent = item.c;
          link.appendChild(category);
        }

        li.appendChild(link);
        results.appendChild(li);
      });
    }

    function reset() {
      results.textContent = '';
      results.hidden = true;
      if (empty) empty.hidden = true;
      if (status) status.textContent = '';
      if (browse) browse.hidden = false;
      root.setAttribute('data-has-query', 'false');
    }

    function update() {
      var raw = input.value || '';
      var tokens = tokenize(raw);

      if (tokens.length === 0) {
        reset();
        return;
      }

      root.setAttribute('data-has-query', 'true');
      var found = search(tokens);
      var hits = rank(found.hits, tokens);

      if (browse) browse.hidden = true;

      if (hits.length === 0) {
        results.hidden = true;
        results.textContent = '';
        if (emptyTerm) emptyTerm.textContent = raw.trim();
        if (empty) empty.hidden = false;
        if (status) status.textContent = '「' + raw.trim() + '」に一致する質問は見つかりませんでした。';
        return;
      }

      render(hits);
      results.hidden = false;
      if (empty) empty.hidden = true;

      if (status) {
        var shown = Math.min(hits.length, limit);
        var text = hits.length + '件見つかりました。';
        if (hits.length > shown) text += '（上位' + shown + '件を表示）';
        if (found.widened) text = '質問文では見つからなかったため、カテゴリ名で探しました。' + text;
        status.textContent = text;
      }
    }

    /* GA4: 打鍵のたびではなく、入力が落ち着いてから 1 回だけ送る */
    var gaTimer = null;
    var lastSent = '';

    function sendSearchEvent() {
      var term = (input.value || '').trim();
      if (!term || term === lastSent) return;
      if (typeof window.gtag !== 'function') return;
      lastSent = term;
      var tokens = tokenize(term);
      var count = tokens.length ? search(tokens).hits.length : 0;
      window.gtag('event', 'search_faq', {
        search_term: term,
        faq_result_count: count
      });
    }

    function scheduleSearchEvent() {
      if (gaTimer) clearTimeout(gaTimer);
      gaTimer = setTimeout(sendSearchEvent, 800);
    }

    input.addEventListener('input', function () {
      update();
      scheduleSearchEvent();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // フォーム送信もページ遷移もさせない
        if (gaTimer) clearTimeout(gaTimer);
        sendSearchEvent();
      }
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        reset();
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        reset();
        input.focus();
      });
    }

    reset();
    if (input.value) update(); // 戻るボタンで値が復元された場合
  }

  /* ------------------------------------------------------------------ *
   * B. カテゴリページのアンカー補助
   *    <details id="q-xxx"> をアンカー遷移で開く。
   *    位置合わせは CSS の scroll-margin-top に任せる。
   * ------------------------------------------------------------------ */
  function initAccordion(root) {
    function openById(id) {
      if (!id) return false;
      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return false;

      var details = target.tagName === 'DETAILS' ? target : target.closest('details');
      if (details) details.open = true;

      // ハッシュ付きで読み込まれた直後は、開く前の位置でスクロールが確定している
      window.requestAnimationFrame(function () {
        (details || target).scrollIntoView({ block: 'start', behavior: 'auto' });
      });
      return true;
    }

    function openFromHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var id = hash.slice(1);
      try {
        id = decodeURIComponent(id);
      } catch (e) {
        /* 不正なエスケープはそのまま扱う */
      }
      openById(id);
    }

    // 同じアンカーを連続で押すと hashchange が起きないので、click でも拾う
    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      try {
        id = decodeURIComponent(id);
      } catch (e) {
        /* そのまま */
      }
      if (openById(id)) {
        event.preventDefault();
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + id);
        }
      }
    });

    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  }

  function init() {
    var searchRoot = document.querySelector('[data-faq-search]');
    if (searchRoot) initSearch(searchRoot);

    var accordionRoot = document.querySelector('[data-faq-accordion]');
    if (accordionRoot) initAccordion(accordionRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
